import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useContentHeaderActions, useIsAdminLayout } from '../AdminLayout/adminLayoutContext'

type OverTheTopSectionProps = {
  children: ReactNode
}

export const OverTheTopSection = ({ children }: OverTheTopSectionProps) => {
  const headerActions = useContentHeaderActions()
  const isAdminLayout = useIsAdminLayout()

  if (headerActions?.slot) {
    return createPortal(children, headerActions.slot)
  }

  // The -130px offset is calibrated to the legacy title and tab strip; under the new layout there
  // is no strip to clear, so a page with no header slot would throw its children off the viewport
  if (isAdminLayout) {
    return <div className='flex justify-end'>{children}</div>
  }

  return <div className='absolute top-[-130px] ltr:right-0 rtl:left-0'>{children}</div>
}
